import { render } from "./Pray.vue?vue&type=template&id=9485c308&scoped=true"
import script from "./Pray.vue?vue&type=script&lang=js"
export * from "./Pray.vue?vue&type=script&lang=js"

import "./Pray.vue?vue&type=style&index=0&id=9485c308&scoped=true&lang=css"

import exportComponent from "/var/www/html/dongan_teens2_check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9485c308"]])

export default __exports__